import { UserProfile, UserRole } from '../../auth/types/auth.types';
import { APP_CONFIG } from '../../shared/config/app.config';

const BACKEND_URL = APP_CONFIG.API.BACKEND_URL;

export const AdminService = {
  async getAllUsers(token: string): Promise<UserProfile[]> {
    const res = await fetch(`${BACKEND_URL}/users`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!res.ok) throw new Error('Error al obtener usuarios');
    return res.json();
  },

  async updateUserRole(token: string, userId: string, role: UserRole): Promise<UserProfile> {
    const res = await fetch(`${BACKEND_URL}/users/${userId}/role`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ role }),
    });
    if (!res.ok) throw new Error('Error al actualizar rol');
    return res.json();
  },

  async deleteUser(token: string, userId: string): Promise<void> {
    const res = await fetch(`${BACKEND_URL}/users/${userId}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${token}` },
    });
    if (res.ok) return;
    // El backend explica por qué no se puede borrar (p.ej. que imparte clases y
    // hay que reasignarlas). Un «Error al eliminar usuario» a secas deja al
    // admin sin saber qué hacer.
    const body = (await res.json().catch(() => null)) as {
      message?: string;
    } | null;
    throw new Error(body?.message ?? 'Error al eliminar usuario');
  },
};
